module.exports = require('./lib/uslug');


//////////////////
// WEBPACK FOOTER
// ./~/uslug/index.js
// module id = 808
// module chunks = 0